import { notification } from 'antd';

import {
  AdminFonctionnelControllerApi,
  DossierDtoAdminFonctionnel,
  DossierResponseDto,
  ForceOrdreControllerApi,
} from 'lib_api/lib/api/gen';

export type ControllerApi =
  | AdminFonctionnelControllerApi
  | ForceOrdreControllerApi;

export type SetDossierAdminF = (dossier: DossierDtoAdminFonctionnel) => void;
export type SetDossierFo = (dossier: DossierResponseDto) => void;

export interface fetchArPndNotificationResult {
  fetchArPndNotification: () => void;
}
export interface fetchCourrierNotificationResult {
  fetchCourrierNotification: () => void;
}

export function isInstanceOfAdminFonctionnel(
  controller: ControllerApi,
): controller is AdminFonctionnelControllerApi {
  return controller instanceof AdminFonctionnelControllerApi;
}

export function displayWarning(): void {
  notification.warn({
    message: 'Le document demandé n’est pas disponible.',
    description: `NB : La durée de rétention par l’ANTAI est de 90 jours`,
    duration: 0,
    placement: 'topLeft',
    style: {
      width: 450,
    },
  });
}
